




















































// vendor
import { defineComponent, computed, ref, PropType, set } from "@vue/composition-api";
import { format as formatDate } from "date-fns";
// project
import * as AssetAPI from "@/services/api/assets";
import { formatDateStringRecent } from "@/utils/text";
import { Asset, AssetVersion } from "@/psychlab/types/assets";
// import { EditText, IEditTextModal } from "@/components.generic/utility-modal";
// import { Confirm, IConfirmModal } from "@/components.generic/utility-modal";
import { ContextOption } from "@/components.generic/context-menu";
import * as AppModal from "@/AppModal";

export default defineComponent({

	emits:[
		"click",
		"restore",
	],
	props:{
		version:{
			type:Object as PropType<AssetVersion<any>>,
			required:true,
		},
		active:{
			type:Boolean,
			default:false,
		},
		latest:{
			type:Boolean,
			default:false,
		},
		disabled:{
			type:Boolean,
			default:false,
		},
		showContext:{
			type:Boolean,
			default:true,
		},
	},
	components:{
		// EditText,
		// ContextMenu,
		// Confirm,
	},
	setup(props, context){

		// const editTextModal = ref<IEditTextModal>();
		// const confirmModal = ref<IConfirmModal>();
		// const contextMenu = ref<IContextMenu>();

		const versionName = computed(() => {
			return props.version.name || `Version ${props.version.vIndex + 1}`;
		});

		const dateLabel = computed(() => {
			return formatDate(new Date(props.version.created), "EEE LLL d Y @ HH:mm");
		});
		
		const onClick = (e:Event) => {
			context.emit("click", e);
		};

		const restore = () => {
			AppModal.confirm({
				title:"Restore Asset Version",
				description:"This will create a copy of the version and push it to the top. Are you sure?",
				okText:"I Understand",
				cancelText:"Cancel",
				variant:"info"
			}, () => {
				context.emit("restore");
			});
		};

		const rename = () => {
			AppModal.editText({
				title:"Set Name",
				value:props.version.name || "",
				validator(v){
					return v !== props.version.name;
				}
			}, async(v) => {
				await AssetAPI.setAssetVersionName(props.version.asset, props.version._id, v);
				// props.version.name = v;
				set(props.version, "name", v);
			});
		};

		const openContext = (e:Event) => {

			e.stopPropagation();

			const options:ContextOption[] = [];

			options.push({
				name:"Edit Name",
				icon:"mdi.pencil-box",
				fn(){
					rename();
				}
			});

			if(!props.latest){
				options.push({
					name:"Restore Version",
					icon:"mdi.restore",
					fn(){
						restore();
					}
				})
			}

			AppModal.context(e, options);
		};

		return {
			versionName,
			// editTextModal,
			// contextMenu,
			onClick,
			openContext,
			dateLabel,
			// confirmModal,
		};
	}
});

